import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetFooter,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet';
import { useAuth } from '@auth';
import { Menu } from 'lucide-react';
import Close from '@/assets/icons/Close.svg?react';
import SignOut from '@/assets/icons/signOut.svg?react';
import Support from '@/assets/icons/heart.svg?react';
import Terms from '@/assets/icons/terms.svg?react';
import Privacy from '@/assets/icons/privacy.svg?react';
import { useState } from 'react';
import { Button } from './ui/button';
import { usePostHog } from 'posthog-js/react';
export default function SettingsDrawer() {
  const { signOut } = useAuth();
  const posthog = usePostHog();

  const handleSignOut = () => {
    setOpen(false);
    signOut();
    posthog.reset();
  };

  const [isOpen, setOpen] = useState(false);

  return (
    <Sheet onOpenChange={setOpen} modal={false} open={isOpen}>
      <SheetTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          onClick={() => setOpen(true)}
          className="text-foreground hover:text-foreground focus:text-foreground"
        >
          <Menu />
        </Button>
      </SheetTrigger>
      <SheetContent className="bg-primary w-50 text-white" side="right" hideClose>
        <SheetHeader className="mt-4">
          <SheetClose asChild className="text-white">
            <Close />
          </SheetClose>
          <SheetTitle className="pt-5 pb-2 text-left text-4xl font-bold text-white">
            Menu
          </SheetTitle>
        </SheetHeader>
        <SheetFooter className="absolute bottom-0 left-0 w-full flex-col p-6 sm:flex-col">
          <a href="https://policy.enrichnetwork.io/#tos" target="_blank" className={'pb-2'}>
            <div className="flex items-center gap-2">
              <Terms /> <p>Terms of service</p>
            </div>
          </a>
          <a href="https://policy.enrichnetwork.io/#privacy" target="_blank" className={'pb-2'}>
            <div className="flex items-center gap-2">
              <Privacy /> <p>Privacy policy</p>
            </div>
          </a>
          <a href="mailto:support@enrichnetwork.io" target="_blank" className={'pb-5'}>
            <div className="flex items-center gap-2">
              <Support /> <p>Support</p>
            </div>
          </a>
          <Button variant="enrich_menu_outline" className="mt-5" onClick={handleSignOut}>
            <SignOut />
            Sign Out
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
